import { Avatar, Badge, Card, Pane, Strong, Text } from "evergreen-ui";
import React from "react";
import { getFormattedDate, getFormattedTime } from "../../util";

export default function BulkBookingCard({
  showBulkBookingDetailsDialog,
  booking,
  index,
  customerDetails,
  bookingStatusIntentMap,
}) {
  return (
    <Card
      id="booking-details"
      key={index}
      position="relative"
      display={"flex"}
      flexDirection={"column"}
      elevation={1}
      width={"95vw"}
      padding={10}
      marginTop={16}
      marginLeft={10}
      marginRight={10}
      onClick={() => showBulkBookingDetailsDialog(booking, index)}
    >
      <Pane display={"flex"} alignItems={"center"}>
        <Avatar name={customerDetails?.name} size={30} />
        <Pane display={"flex"} justifyContent={"space-between"} width={"100%"}>
          <Strong marginLeft={5}>{customerDetails?.name}</Strong>
          <Strong textDecoration={"underline"} color={"selected"}>
            {booking.patternBookingId}
          </Strong>
        </Pane>
      </Pane>
      <Pane
        marginLeft={35}
        marginTop={5}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Strong>{booking["sport"]}</Strong>
        <Badge color={bookingStatusIntentMap[booking.status.toLowerCase()]}>
          {booking?.status}
        </Badge>
      </Pane>
      <Pane
        marginLeft={35}
        marginTop={10}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Text color={"muted"}>
          {`${customerDetails["mobile"]} |
                              ${customerDetails["email"]}`}
        </Text>
      </Pane>
      <Pane
        marginLeft={35}
        marginY={10}
        display={"flex"}
        flexDirection={"column"}
        justifyContent={"space-between"}
      >
        <Pane
          display={"flex"}
          width={"100%"}
          marginBottom={5}
          justifyContent={"space-between"}
          flexDirection={"row"}
        >
          <Strong>From Date</Strong>
          <Strong>To Date</Strong>
        </Pane>
        <Pane
          display={"flex"}
          width={"100%"}
          justifyContent={"space-between"}
          flexDirection={"row"}
          marginBottom={5}
        >
          <Text>{booking.startDate}</Text>
          <Text>{booking.endDate}</Text>
        </Pane>
      </Pane>
      <Pane
        marginLeft={35}
        marginTop={5}
        marginBottom={5}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Text color={"muted"}>
          {`${getFormattedDate(
            booking["timestamp"],
            "YYYY-MM-DD HH:mm:ss",
            "ddd, Do MMM"
          )} |
                              ${getFormattedTime(booking["startTime"])} -
                              ${getFormattedTime(booking["endTime"])}`}
        </Text>
      </Pane>
    </Card>
  );
}
